import * as api from "api"
import { toggleLoader } from "signals/base"
import { back_event, catch_error } from "./base"
import { changeFormData, form_data } from "signals/form"
import { get_cities, get_districts, get_provinces } from "./region"
import { err_msg } from "helper"
import { toggleToast } from "signals/modal"

const get_form_by_id = (id) => {
	toggleLoader(true)
	api
		.form_by_id(id)
		.then((response) => {
			const { form } = response.data.data
			let result = form[0]
			form_data.value = result
			let country = Object.keys(result.country)[0]
			let province = Object.keys(result.province)[0]
			let city = Object.keys(result.city)[0]
			let mapping = ["country", "province", "city", "district", "country_dial_code"]
			for (var i = 0; i < mapping.length; i++) {
				let value = Object.keys(result[mapping[i]])[0]
				switch (mapping[i]) {
					case "country":
						// code block
						get_provinces({ country_code: country })
						break
					case "province":
						// code block
						get_cities({ country_code: country, province_code: province })
						break
					case "city":
						// code block
						get_districts({ country_code: country, province_code: province, city_code: city })
						break
					default:
				}
				changeFormData(mapping[i], value)
			}
		})
		.catch((err) => {
			/** Handle error , show modal or toast error */
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}

const create_address = (formData) => {
	toggleLoader(true)
	api
		.create_form(formData)
		.then(() => {
			toggleToast({ msg: `toast_success_create_form`, state: true, type: "success" })
			setTimeout(() => {
				back_event()
			}, 2000)
		})
		.catch((err) => {
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}

const edit_address = (id, formData, event_data) => {
	toggleLoader(true)
	api
		.edit_form({
			form_id: id,
			new_data: formData,
			event: event_data,
		})
		.then(() => {
			toggleToast({ msg: `toast_success_update_form`, state: true, type: "success" })
			setTimeout(() => {
				back_event()
			}, 2000)
		})
		.catch((err) => {
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}
export { get_form_by_id, create_address, edit_address }
